import { render, staticRenderFns } from "./EsportMatchCardView.vue?vue&type=template&id=1bb0ed06&scoped=true"
import script from "./EsportMatchCardView.vue?vue&type=script&setup=true&lang=js"
export * from "./EsportMatchCardView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EsportMatchCardView.vue?vue&type=style&index=0&id=1bb0ed06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0ed06",
  null
  
)

export default component.exports